import { gql } from '@apollo/client';

import { StudentOnlineApplicationFragment } from '@modules/students/graphql';

export const UpdateStudentOnlineApplicationMutation = gql`
    mutation UpdateStudentOnlineApplication($item: StudentOnlineApplicationFill!) {
        updateStudentOnlineApplication(item: $item) {
            ...StudentOnlineApplication
        }
    }
    ${StudentOnlineApplicationFragment}
`;
